export const MOBILE_APP_QUESTION_TEXT =
  'A mobile app is being loaded for you to interact with.';

export interface MobileAppQuestionSource {
  readonly text?: string | null;
  readonly mobileAppEmbedUrl?: string | null;
}

export function isMobileAppQuestion(source: MobileAppQuestionSource): boolean {
  return (
    source.text?.trim() === MOBILE_APP_QUESTION_TEXT ||
    !!source.mobileAppEmbedUrl?.trim()
  );
}

export function hasMobileAppQuestion(
  questions: readonly MobileAppQuestionSource[]
): boolean {
  return questions.some(isMobileAppQuestion);
}
